import React from 'react';

const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
    <div className="bg-white p-4 sm:p-6 rounded shadow-lg w-[90%] sm:w-[65%] max-h-[90vh] overflow-y-auto relative modal-scrollable">
      <div className="flex justify-between items-center mb-2">
        <h2 className="text-2xl font-semibold text-gray-800">Customer Product Details</h2>
        <button
          onClick={onClose}
          className="bg-[#1C50A3] text-white w-8 h-8 flex items-center justify-center rounded-full text-xl leading-none focus:outline-none"
        >
          &times;
        </button>
      </div>
      <div className="-mx-6">
        <hr className="border-gray-300" />
      </div>
      <div className="">
        {children}
      </div>
    </div>
  </div>
  
  );
};

export default Modal;
